import { getOpeningHours } from '@df/catalog/store/get-opening-hours';
import { getTodayOpeningHours } from '@df/catalog/store/get-today-opening-hours';
import { IDay } from '@df/catalog/store/store';
import { Metapack } from './metapack.namespace';

export class MetapackCollectionPoint {
    type = Metapack.COLLECTION_POINT_TYPE;

    id!: string;

    openingHours?: IDay[];
    todayOpeningHours?: IDay;

    constructor(public data: Metapack.ICollectionPointData) {
        this.id = data.booking_code;
        if (data.days) {
            this.openingHours = getOpeningHours(data.days);
            this.todayOpeningHours = getTodayOpeningHours(this.openingHours);
        }
    }

    /**
     * Selection data required to select this point as delivery method
     * @returns {Metapack.ICollectionPointSelectionData}
     */
    getSelectionData(): Metapack.ICollectionPointSelectionData {
        const { booking_code, postcode, country_id } = this.data;
        return { booking_code, postcode, country_id, store_id: null };
    }

    get distance(): number | undefined {
        return this.data ? this.data.distance : undefined;
    }

    get directions(): string | undefined {
        if (this.data && this.data.latitude && this.data.longitude) {
            return 'https://www.google.com/maps/dir/Current+Location/' + this.data.latitude + ',' + this.data.longitude;
        }
        return undefined;
    }

    get collectionDate(): string | undefined {
        if (this.data) {
            return this.data.collection_from;
        }
        return undefined;
    }

    get secondLine(): string {
        if (this.data) {
            return [this.data.city, this.data.region, this.data.postcode].filter(i => !!i).join(', ');
        }
        return '';
    }
}
